import { SmallButton } from 'src/elements/Button'
import {
  truewhite,
  _feedbacknote,
  _messagebutton,
  _messagebuttonbg,
} from 'src/styles/colors'
import { fontWeightBold, fontWeightMedium } from 'src/styles/font'
import styled from 'styled-components'

export const ButtonsDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  > * {
    margin: 0 8px;
  }
`
export const Button = styled(SmallButton)`
  color: ${_messagebutton};
  background-color: ${_messagebuttonbg};
  border: 1px solid ${_messagebuttonbg};

  :disabled {
    opacity: 50%;
    cursor: not-allowed;
  }
`
export const CancelButton = styled(Button)`
  background-color: ${_messagebutton};
  color: ${_messagebuttonbg};
  border-color: ${_messagebutton};
`

export const Layout = styled.div`
  width: 100%;
  padding: 32px;
  border-radius: 10px;
  background: ${truewhite};

  h3 {
    font-size: 18px;
    font-weight: ${fontWeightBold};
  }
  p {
    margin-top: 10px;
    font-weight: ${fontWeightMedium};
    white-space: pre-wrap;
  }
  ${ButtonsDiv} {
    margin-top: 48px;
  }
`

export const Note = styled.p`
  font-size: 12px;
  color: ${_feedbacknote};
`
